export const WARRANTY_CARDS_FEATURE_FLAG = false;

export const TEST_FEATURE_FLAG = true;
